import { Box, Container, Typography } from "@mui/material";
import React from "react";
import icon from './icon_small.png';
import { Link } from "react-router-dom";
import { Motion } from "../../Components/Motion";

export const NAVBAR_HEIGHT = 50; // px
export const NAVBAR_SPACE = { xs: "14px", sm: "50px", md: "50px" };

export const colorBase = "#a0a0a0";
export const colorBlue = "#0265F4";
export const colorBlueDark = "#001949";
export const colorRed = "#F54F64";
export const colorRedDark = "#E52F24";
export const colorGrey = "#73757A";

export const highlightColor = "#F3F8FF";
export const appYellow = "#FBC42C";

export const bgcolor = "#F3F3F3";

export const colorGreen = "#0C915A";
export const colorGreenDark = "#055132";

export const footerColor = "#021433";

export const FOOTER_HEIGHT = 160;

export const fullCenter = {
  display: 'flex', alignItems: 'center', alignContent: 'center', justifyContent: 'center'
};

// import { ReactComponent as SomeName } from "./SomeName.svg";
export const SvgComponent = ({ svg, sx = {}, style = {} }) => {
  const editedIcon = React.cloneElement(svg, {
    style: {
      width: "100%",
      height: "100%",
      ...style,
    },
  });
  return <Box sx={{ ...sx }}>{editedIcon}</Box>;
};

export const getAppIcon = () => {
  return icon;
}

export const AppIcon = ({ color = 'white', to = "/" }) => {
  return (
    <Motion scale={1.01}>
      <Box>
        <Box component={Link} to={to} sx={{
          display: 'flex', flexDirection: 'row', alignItems: 'center', alignContent: 'center',
          cursor: 'pointer'
        }}>
          <Box component={'img'} src={getAppIcon()} sx={{
            width: '26px',
            borderRadius: '6px', boxShadow: "2px 2px 5px 0px rgba(0,0,0,0.2)",
          }} />
          <Typography variant='logo' sx={{ ml: '12px', mt: '2px', color }}>Hlídání insolvencí</Typography>
        </Box>
      </Box>
    </Motion>);
}

export const ConsoleNavbar = ({ sx = {}, textColor = "#1A1C1E" }) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: `${NAVBAR_HEIGHT}px`,
        py: "8px",
        px: NAVBAR_SPACE,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        alignContent: "center",
        ...sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          alignContent: "center",
          mr: "auto",
        }}
      >
        <Box
          sx={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: 'center',
            alignContent: 'center',
            textDecoration: "none",
            p: "10px",
            pl: "0px",
          }}
        >
          <AppIcon color={textColor} to={"https://hlidaniinsolvenci.cz/"} />
        </Box>

      </Box>


    </Box>)
}
/*
USAGE:
  <SvgComponent
    svg={<Logo />}
    sx={{
      width: { xs: "300px", sm: "400px" },
      height: { xs: "300px", sm: "400px" },
    }}
  />
*/